import qs from 'qs'
import {
  getQueryString,
  isAlipay,
  isWechat
} from 'common/js/util'
import {
  checkAlipayAuth
} from 'common/js/api'
import axios from 'axios'
import BScroll from 'better-scroll'
export function jumpPage(options) {
  const {
    pageName = 'index', href, param,redirect = false
  } = options
  let url = href ? href : `${this.$baseURL.cat}/dist/${this.$key}/${pageName}.html`
  let urlParam = typeof param === 'string' ? param : qs.stringify(param, {
    encode: false
  })
  let par = url.indexOf('?') > -1 ? '' : urlParam && urlParam.indexOf('?') < 0 ? '?' : ''
  url = url + par + urlParam
  if( isAlipay ){
     if( redirect ){
        ap.redirectTo(url)
     }else if( url.indexOf('alipays://') < 0 ){
        ap.pushWindow(url)
     }else{
        window.location.href = url
     }
  }else{
     window.location.href = url
  }
}

export function setCityStore() {
  const city = this.$storejs.get(`${this.$key}City`) || {}
  const date = this.$dayjs(new Date()).format('YYYY-MM-DD')
  if (!city[date]) {
    this.$storejs.remove(`${this.$key}City`)
    const data = {}
    data[date] = this.$state.city
    this.$storejs.set(`${this.$key}City`, data)
  }
}

export function getCityStore() {
  const city = this.$storejs.get(`${this.$key}City`) || {}
  const date = this.$dayjs(new Date()).format('YYYY-MM-DD')
  if (city[date]) {
    this.$state.city = city[date]
  }
}

export async function indexAuth() {
  const type = getQueryString('type') || ''
  // const notFirst = this.$storejs.get(`${this.$key}saveFirm`) || 1
  //是否没有选择意向车型，分享二维码的入口，到时间没有
  let pageName = type === 'message' ? 'message' : type === 'guess' ? 'game' : this.stopDrawTime === 'end' ? `message` : `game`
  const url = `${this.$baseURL.cat}/dist/${this.$key}/${pageName}.html${window.location.search}`
  const res = await checkAlipayAuth.call(this, url)
  // 统计信息
  let label
  if (isAlipay) {
    label = '支付宝'
  } else if (isWechat) {
    label = '微信'
  } else {
    label = '其他'
  }
  typeof _czc !== 'undefined' && _czc.push(['_trackEvent', `${this.$key}`,'推广页跳转游戏页' , label])
  if (res.code === 0) {
    window.location.href = url
  } else if (res.code === 5) {
    window.location.href = res.data.jump_url
  } else {
    this.$toast(res.msg)
  }
}
export async function gameAuth() {
  const res = await checkAlipayAuth.call(this, window.location.href)
  if (res.code === 0) {
    this.$state.authInfo = res.data
    this.$storejs.set(`${this.$key}ShareUserInfo`, this.$state.authInfo)
  } else if (res.code === 5) {
    window.location.href = res.data.jump_url
  } else {
    this.$toast(res.msg)
  }
}
export async function getInvite() {
  const invite = this.$storejs.get(`${this.$key}Invite`)
  if (invite && this.$env === 'prod') {
    return
  }
  if (!getQueryString('mid')) {
    return
  }
  const res = await this.$post({
    baseURL: this.$baseURL.cat,
    url: `/activity/${this.$key}/invite`,
    data: {
      mid: getQueryString('mid')
    }
  })
  if (res.code === 0) {
    this.$storejs.set(`${this.$key}Invite`, true)
  } else {
    this.$toast(res.msg)
  }
}
export async function getFirmList(brandId) {
  return this.$get({
    baseURL: this.$baseURL.api,
    url: '/v1/comm/carfirms',
    params: {
      carbrand_id: brandId
    }
  })
}


export async function getConfigInfo() {
  return this.$get({
    baseURL: this.$baseURL.cat,
    url: `/activity/${this.$key}/brands`,
    params: {
       brand_id: getQueryString('bid')
    }
  })
}
async function uploadImg(file, token, type, callback) {
  const formData = new FormData()
  formData.append('token', token)
  formData.append('file', file)
  formData.append(
    'key',
    Math.random()
    .toString(36)
    .substr(2) +
    Math.random()
    .toString(36)
    .substr(2) +
    '.jpg'
  )
  axios({
      url: 'https://upload.qiniup.com',
      method: 'POST',
      data: formData
    })
    .then(result => {
      const res = result.data
      const link = 'https://a-img.pangku.com/' + res.key
      callback && callback(type, link)
    })
    .catch(err => {
      console.log(err)
      this.$toast('生成失败，请刷新再试')
    })
}
export async function getQiniuToken(file, type, callback) {
  const res = await this.$get({
    baseURL: this.$baseURL.cat,
    url: '/api/get_qiniu_token'
  })
  if (res.code === 0) {
    uploadImg.call(this, file, res.data.token, type, callback)
  } else {
    this.$toast(res.msg)
  }
}
export async function getTaskInfo() {
  const res = await this.$get({
    baseURL: this.$baseURL.cat,
    url: `/activity/${this.$key}/tasks/list`
  })
  if (res.code === 0) {
    this.$state.taskList = formatTaskList(res.data)
    const task = this.$storejs.get(`${this.$key}isTask`) || false
    if(!task){
      this.$nextTick(res=>{
        this.$refs.taskAlert.openTaskPopup()
      })
    }else{
      this.$nextTick(res=>{
        this.$refs.video.loadplayer(this.$state.brandInfo.ad_video)
      })
    }
  } else {
    this.$toast(res.msg)
  }
}
function formatTaskList(list) {
  // 邀请任务置底
  const index = list.findIndex(ele => {
    return ele.id === 't_1'
  })
  const arr = list.splice(index, 1)
  list.splice(list.length, 0, arr[0])
  // 完成和未完成的任务分开
  const list1 = list.filter(ele => {
    return ele.num > 0
  })
  const list2 = list.filter(ele => {
    return ele.num === 0
  })
  const formatTaskList = [...list1, ...list2]
  // 返回整理后的列表
  return formatTaskList
}
export async function getUserInfo() {
  const res = await this.$get({
    baseURL: this.$baseURL.cat,
    url: `/activity/${this.$key}/user/info`
  })
  if (res.code === 0) {
    this.$state.userInfo = res.data
    this.$storejs.set(`${this.$key}saveFirm`,res.data.is_checkIn)
  } else {
    thos.$toast(res.msg)
  }
}
export async function uploadInvoice(data) {
  return this.$post({
    baseURL: this.$baseURL.cat,
    url: `/activity/${this.$key}/checkIn/leave`,
    data
  })
}
export async function getTeams() {
  //如果冠军出来了，就没必要请求团队接口
  const endTime = this.openTimes[2]
  if (this.serverTime.diff(this.$dayjs(endTime)) > 0) {
    return
  }
  const res = await this.$get({
    baseURL: this.$baseURL.cat,
    url: `/activity/${this.$key}/game/teams`,
  })
  if (res.code === 0) {
    this.$state.teams = res.data
  } else {
    thos.$toast(res.msg)
  }
}
export async function gameVote(data) {
  return await this.$post({
    baseURL: this.$baseURL.cat,
    url: `/activity/${this.$key}/game/vote`,
    data
  })
}
export async function openDraw(tab) {
  const res = await this.$get({
    baseURL: this.$baseURL.cat,
    url: `/activity/${this.$key}/game/lottery`,
  })
  if (res.code === 0) {
    this.$state.drawResult[this.maxs[tab].key] = res.data[this.maxs[tab].key]
  } else {
    this.$toast(res.msg)
  }
}
export async function openLottery(cnum) {
  return await this.$post({
    baseURL: this.$baseURL.cat,
    url: `/activity/${this.$key}/luck/lottery`,
    data: {
      cnum
    }
  })
}
export async function getPrizeList() {
  return await this.$get({
    baseURL: this.$baseURL.cat,
    url: `/activity/${this.$key}/luck/list`
  })
}
export async function getDrawList() {
  return await this.$get({
    baseURL: this.$baseURL.cat,
    url: `/activity/${this.$key}/message/lottery`
  })
}
